window.Size = function() {
    var el = this;
    el.current = {};
    el.items = {};
    el.availables = {};
    
    var template = $('#product-sizes-template').html();
    
    el.init = function() {
        var productId = el.product.id;

        if (!el.availables.hasOwnProperty(productId)) {
            el.current = {
                id: 0
            };
            
            return true;
        }
        
        var sizeId = 0;
        
        if (el.items.hasOwnProperty(el.project.current.constructor.size_id)) {
            sizeId = parseInt(el.project.current.constructor.size_id);
        }
        
        if (sizeId === 0) {
            sizeId = parseInt(el.availables[productId][0]);
        }
        
        el.current = el.items[sizeId];
    };
    
    el.render = function() {
        var productId = el.product.id;
        
        var templateData = {
            items: [],
            is_show: false
        };
        
        var i, sizeId;
        if (el.availables.hasOwnProperty(productId)) {
            for (i in el.availables[productId]) {
                sizeId = el.availables[productId][i];
                
                templateData.items.push({
                    is_active: sizeId === el.current.id ? true : false,
                    id: sizeId,
                    letter: el.items[sizeId].letter
                });
            }
        }
        
        templateData.is_show = templateData.items.length > 0 ? true : false;
        
        var html = el.templater.render(template, templateData);
        $('.product-sizes').html(html);
    };
    
    el.set = function (id) {
        el.current = el.items[id];
        el._parent.workData.size_id = id;
        
        el.render();
    };
    
    $(document).on('change', '.js-set-size', function () {
        el.set($(this).val());
    });
};